<template>
    <div>
        <div class="grid grid-cols-12 gap-6 border-b-1 pb-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/prameny-seznamy-ulic"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/prameny_seznamy_ulic.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/prameny-seznamy-ulic"
                        class="underline"
                    >
                        Prameny – seznamy ulic
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Jak se měnily názvy pražských ulic? <br />Přehled vývoje
                    seznamů pražských ulic od 18. století po současnost ukazuje,
                    jak se měnily nejen samotné názvy, ale i přístup k jejich
                    evidenci...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/prameny-seznamy-ulic"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/prameny-plany-prahy"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/prameny_plany_prahy.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/prameny-plany-prahy"
                        class="underline"
                    >
                        Prameny – plány Prahy
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Historické plány Prahy – významné, avšak ne vždy zcela
                    spolehlivé prameny pro rekonstrukci uličního názvosloví
                    napříč staletími. Text, mimo jiné, upozorňuje na dvě
                    základní úskalí historických plánů – obtížné nebo
                    nepřesné...
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/prameny-plany-prahy"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 border-b-1 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/ostatni-prameny"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/ostatni_prameny.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/ostatni-prameny"
                        class="underline"
                    >
                        Ostatní prameny
                    </nuxt-link>
                </p>
                <p class="font-medium">
                    Přehled klíčových pramenů k výzkumu názvů pražských ulic –
                    od usnesení zastupitelstev přes kroniky až po fotografie.
                    Zvláštní pozornost je věnována přejmenování ulic po
                    připojení obcí k Praze v letech 1968 a 1974.
                </p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/ostatni-prameny"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <div class="grid grid-cols-12 gap-6 py-6">
            <div class="col-span-12 md:col-span-5">
                <nuxt-link
                    to="/clanky/literatura"
                    class="underline"
                >
                    <img
                        src="../public/img/articles/literatura.webp"
                        alt=""
                        class="aspect-3/2 w-full object-cover"
                    />
                </nuxt-link>
            </div>
            <div class="py:0 col-span-12 md:col-span-7 md:py-2">
                <p class="mb-5 font-bold">
                    <nuxt-link
                        to="/clanky/literatura"
                        class="underline"
                    >
                        Literatura
                    </nuxt-link>
                </p>
                <p class="font-medium">Výběrový seznam tištěné literatury</p>
                <p class="mt-5 font-bold">
                    >
                    <nuxt-link
                        to="/clanky/literatura"
                        class="underline"
                    >
                        více
                    </nuxt-link>
                </p>
            </div>
        </div>

        <AppFooter />
    </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
